import { MutationTree } from 'vuex';
import moment from 'moment';

import { AppointmentState } from './state';
import { GoogleEventI, EventI } from '../calendar/state';

const mutations: MutationTree<AppointmentState> = {
  setAppointments(state: AppointmentState, payload: GoogleEventI[]) {
    state.appointments = [];
    payload.forEach((appointment) => {
      // start and end is in the format of '2021-08-02T09:00:00+08:00'
      // convert it to unix timestamp
      const start = appointment.start.dateTime;
      const end = appointment.end.dateTime;

      const ev: EventI = {
        id: appointment.id,
        summary: appointment.summary,
        description: appointment.description,
        start: moment(start).unix(),
        end: moment(end).unix(),
        htmlLink: appointment.htmlLink,
        status: appointment.status,
      };
      state.appointments.push(ev);
    });
  },
  setAppointment(state: AppointmentState, payload: GoogleEventI) {
    if (!payload) {
      state.appointment = null;
      return;
    }
    const ev: EventI = {
      id: payload.id,
      summary: payload.summary,
      description: payload.description,
      start: moment(payload.start.dateTime).unix(),
      end: moment(payload.end.dateTime).unix(),
      htmlLink: payload.htmlLink,
      status: payload.status,
    };
    state.appointment = ev;
  },
};

export default mutations;
